import "./styles.scss";

export interface IInfoProps {
  chassis: string;
  model: string;
  contractDuration: number;
  licensePlate: string;
  contractNumber: string;
  contractType: string;
  initialOdometer?: number;
  monthlyAverageKm?: number;
  initialHourMeter?: number;
  monthlyAverageHr?: number;
  accountName: string;
  contractStatus: string;
  createdAt?: string;
}

const Info = ({
  chassis,
  model,
  contractDuration,
  licensePlate,
  contractNumber,
  contractType,
  initialOdometer,
  monthlyAverageKm,
  initialHourMeter,
  monthlyAverageHr,
  accountName,
  contractStatus,
  createdAt,
}: IInfoProps) => (
  <section className="margin-bottom-20 contract-details-info">
    <div className="contract-details-info__grid">
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">Chassi:</span>
        <span className="contract-details-info__value">{chassis}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">Status do contrato:</span>
        <span className="contract-details-info__value">{contractStatus}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">Tipo de contrato:</span>
        <span className="contract-details-info__value">{contractType}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">Código do contrato:</span>
        <span className="contract-details-info__value">{contractNumber}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">Data de contratação:</span>
        <span className="contract-details-info__value">{createdAt ? new Date(createdAt).toLocaleDateString("pt-BR") : "—"}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">Modelo:</span>
        <span className="contract-details-info__value">{model}</span>
      </div>
      
      {initialOdometer ? <div className="contract-details-info__row">
        <span className="contract-details-info__label">Odômetro inicial:</span>
        <span className="contract-details-info__value">{`${initialOdometer.toLocaleString("pt-BR")} km`}</span>
      </div> : null}
      
      {initialHourMeter ? <div className="contract-details-info__row">
        <span className="contract-details-info__label">Horímetro inicial:</span>
        <span className="contract-details-info__value">{`${initialHourMeter.toLocaleString("pt-BR")} h`}</span>
      </div> : null}

      <div className="contract-details-info__row">
        <span className="contract-details-info__label">Conta:</span>
        <span className="contract-details-info__value">{accountName}</span>
      </div>
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">Placa:</span>
        <span className="contract-details-info__value">{licensePlate}</span>
      </div>
      
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">Período do contrato:</span>
        <span className="contract-details-info__value">{contractDuration} {contractDuration === 1 ? "mês" : "meses"}</span>
      </div>
      
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">Uso mensal estimado:</span>
        <span className="contract-details-info__value">
          {monthlyAverageKm ? `${monthlyAverageKm.toLocaleString("pt-BR")} km` : null}
          {monthlyAverageHr ? `${monthlyAverageHr.toLocaleString("pt-BR")} h` : null}
        </span>
      </div>
      
      <div className="contract-details-info__row">
        <span className="contract-details-info__label">Cobertura total do plano:</span>
        <span className="contract-details-info__value">
          {monthlyAverageKm ? `${(monthlyAverageKm * contractDuration).toLocaleString("pt-BR")} km` : null}
          {monthlyAverageHr ? `${(monthlyAverageHr * contractDuration).toLocaleString("pt-BR")} h` : null}
        </span>
      </div>
    </div>
  </section>
);

export default Info;
